  /*global jQuery */
	(function($) {
		
	'use strict';

  $('.slide-loghi').owlCarousel({
			loop:false,
			interval: 2000,
			pause: "false",
			smartSpeed: 1000,
			items:4,
			dots: true,
			autoplay:true,
			autoplayTimeout:5000,
			autoplayHoverPause:false,
			nav: true,
			navText : ['<span class="glyphicon glyphicon-chevron-left" style="top: 11px;color:grey;"></span>','<span class="glyphicon glyphicon-chevron-right" style="top: 11px;color:grey;"></span>'],
		});

    $('.slide-immagini').owlCarousel({
			loop:true,
			interval: 2000,
			pause: "false",
			smartSpeed: 1000,
			items:1,
			dots: true,
			autoplay:true,
			autoplayTimeout:5000,
			autoplayHoverPause:false,
			nav: true,
			navText : ['<span class="glyphicon glyphicon-chevron-left" style="top: 11px;color:grey;"></span>','<span class="glyphicon glyphicon-chevron-right" style="top: 11px;color:grey;"></span>'],
		});

}(jQuery));
